import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress
} from '@mui/material';
import {
  Schedule as ScheduleIcon,
  PlayArrow as ActiveIcon,
  Pause as PausedIcon,
  Error as ErrorIcon
} from '@mui/icons-material';

export default function JobStatusCards({ stats, ...props }) {
  const cards = [
    {
      title: 'Total Schedules',
      value: stats.total_schedules || 0,
      icon: <ScheduleIcon />,
      color: 'primary'
    },
    {
      title: 'Active Schedules',
      value: stats.active_schedules || 0,
      icon: <ActiveIcon />,
      color: 'success'
    },
    {
      title: 'Paused Schedules',
      value: stats.paused_schedules || 0,
      icon: <PausedIcon />,
      color: 'warning'
    },
    {
      title: 'Running Jobs',
      value: stats.running_jobs || 0,
      icon: <ActiveIcon />,
      color: 'info'
    }
  ];

  return (
    <Grid container spacing={3} {...props}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography color="text.secondary" gutterBottom variant="body2">
                    {card.title}
                  </Typography>
                  <Typography variant="h4" component="div">
                    {card.value}
                  </Typography>
                </Box>
                <Box sx={{ color: `${card.color}.main`, opacity: 0.7 }}>
                  {card.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
      
      {/* Success Rate Card */}
      <Grid item xs={12} sm={6} md={6}>
        <Card>
          <CardContent>
            <Typography color="text.secondary" gutterBottom variant="body2">
              Success Rate (24h)
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="h4" component="div">
                {stats.success_rate_24h || 0}%
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <LinearProgress 
                  variant="determinate" 
                  value={stats.success_rate_24h || 0}
                  color="success"
                  sx={{ height: 8, borderRadius: 4 }}
                />
              </Box>
            </Box>
            {stats.failed_jobs_24h > 0 && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {stats.failed_jobs_24h} failed jobs in last 24h
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
